(function() {
  const SHOPIFY_PARAMS = ["variant", "page", "sort_by", "q", "type", "advert", "reload"];
  const STORE_DOMAIN = window.location.origin;

  function getQueryParams(url) {
    let params = new URL(url, STORE_DOMAIN).searchParams;
    let paramObj = {};
    for (let [key, value] of params) {
      paramObj[key] = value;
    }
    return paramObj;
  }

  function filterCustomParams(params) {
    let filteredParams = {};
    for (let key in params) {
      if (!SHOPIFY_PARAMS.includes(key)) {
        filteredParams[key] = params[key];
      }
    }
    return filteredParams;
  }

  function serializeParams(params) {
    return new URLSearchParams(params).toString();
  }

  function updateLinks() {
    let currentParams = filterCustomParams(getQueryParams(window.location.href));
    if (Object.keys(currentParams).length === 0) return;

    console.log('start link changing');
    document.querySelectorAll("a[href]").forEach(link => {
      let href = link.getAttribute("href");

      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) return;

      let isRelative = !href.startsWith("http") && !href.startsWith("//");
      let url = new URL(href, STORE_DOMAIN);

      if (url.origin !== STORE_DOMAIN) return;

      let existingParams = getQueryParams(url);
      let mergedParams = { ...currentParams, ...existingParams };
      let newQueryString = serializeParams(mergedParams);

      link.setAttribute("href", isRelative ? `${url.pathname}?${newQueryString}` : `${url.origin}${url.pathname}?${newQueryString}`);
    });
  }

  document.addEventListener("DOMContentLoaded", updateLinks);
})();
